import { gql } from '@apollo/client';

export const GET_RETURN_INCENTIVE_PRODUCTS = gql`
  query GetReturnIncentiveProducts($input: ReturnIncentiveProductsInput!) {
    returnIncentiveProducts(input: $input) {
      nodes {
        id
        title
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_RETURN_INCENTIVE_COLLECTIONS = gql`
  query GetReturnIncentiveCollections(
    $input: ReturnIncentiveCollectionsInput!
  ) {
    returnIncentiveCollections(input: $input) {
      nodes {
        id
        title
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
